import React, { useEffect } from "react";
import AOS from "aos";
import page_json from "./config/config.json";
import ContactForm from "./ContactForm";
import { Helmet } from "react-helmet";
import ContactUsButton from "./ContactUsButton";
import TechnologyAlliances from "./TechnologyAlliances";
import MarqueeComponent from "./MarqueeComponent";
import HeroComponent from "./HeroComponent";
import config from '../config';

const textDataUrl = `${page_json.page_jsons.DigitalTransformation}?v=${config.VERSION}`;
const textDataResponse = await fetch(textDataUrl);
const textData = await textDataResponse.json();

function DigitalTransformation() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div data-aos="fade-up" className="dtPage">
      <Helmet>
        <meta
          name="description"
          content="Navigate complex business and IT environments with a robust Digital ecosystem"
        />
        <title>Digital Transformation | Services | Engineersmind</title>
      </Helmet>

      <HeroComponent
      bgImageMobile={textData.layer1.mobilebannerimg}
        bgImage={textData.layer1.img}
        textContent={
          <h1>
            {textData.layer1.heading.text1}{" "}
            <span>
              {textData.layer1.heading.text2}
               {textData.layer1.heading.text3}
            </span>
            {textData.layer1.heading.text4}
            <br />
            {textData.layer1.heading.text5}
          </h1>
        }
        breadcrumbs={
          <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="/">Home </a>
          </li>
          <li className="breadcrumb-item">
            <a href="/Services/Digital-Transformation">Services </a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Digital Transformation
          </li>
        </ol>
        }
      />

      <div className="container-fluid manufacture full-height-section">
        <div className="container">
          <div className="row manufacture-row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center align-items-center">
              <img
                src={textData.layer2.img}
                className="img-fluid wrapimg-with-text float-start me-4"
                alt="industry"
              />
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
              <p className="text-20 para">{textData.layer2.body.text1}</p>&nbsp;
              <p className="text-align-justify text-20">
                {textData.layer2.body.text2}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-0"><span>{textData.layer3.heading}</span></h1>&nbsp;
          <div className="p-0 text-20">
            <p>{textData.layer3.body.text1}</p>&nbsp;
          </div>
          <div className="row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.layer3.img}
                className="img-fluid ModernPortals-left-img midp1"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal">
                {textData.layer3.keyFeatures.map((feature, index) => {
                  return (
                    <div className="d-flex w-100 list-item" key={index}>
                      <img src={textData.bulletPoints.img} alt="bullet-point" />
                      <div>
                        <p className="fst-italic text-20">
                          <strong>{feature.title}</strong>
                        </p>
                        <p className="portal-desc text-20">{feature.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="pt-4 text-20">
            <p>{textData.layer3.body.text2}</p>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals second">
        <div className="container">  
          <h1 className="mb-0"><span>{textData.layer4.heading}</span></h1>&nbsp;
          <div className="p-0 text-20">
            <p>{textData.layer4.body.text1}</p>&nbsp;
          </div>
          <div className="row full-stack">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal">
                {textData.layer4.keyFeatures.map((feature, index) => {
                  return (
                    <div className="d-flex w-100 list-item" key={index}>
                      <img src={textData.bulletPoints.img} alt="bullet-point" />
                      <div>
                        <p className="fst-italic text-20">
                          <strong>{feature.title}</strong>
                        </p>
                        <p className="portal-desc text-20">{feature.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 full-stack  d-flex justify-content-center align-items-center">
              <img
                src={textData.layer4.img}
                className="img-fluid ModernPortals-left-img2"
                alt="Resilient_solutions"
              />
            </div>
          </div>
          <div className="pt-4 text-20">
            <p>{textData.layer4.body.text2}</p>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals third">
        <div className="container">
          <h1 className="mb-0"><span>{textData.layer5.heading}</span></h1>&nbsp;
          <div className="p-0 text-20">
            <p>{textData.layer5.body.text1}</p>&nbsp;
          </div>
          <div className="row full-stack">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 full-stack  d-flex justify-content-center align-items-center">
              <img
                src={textData.layer5.img}
                className="img-fluid ModernPortals-left-img2"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal">
                {textData.layer5.keyFeatures.map((feature, index) => {
                  return (
                    <div className="d-flex w-100 list-item" key={index}>
                      <img src={textData.bulletPoints.img} alt="bullet-point" />
                      <div>
                        <p className="fst-italic text-20">
                          <strong>{feature.title}</strong>
                        </p>
                        <p className="portal-desc text-20">{feature.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="pt-4 text-20">
            <p>{textData.layer5.body.text2}</p>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals second dataEngineering">
        <div className="container">
          <h1 className="mb-0"><span>{textData.layer6.heading.text1}</span></h1>&nbsp;
          <div className="p-0 text-20">
            <p>{textData.layer6.body.text1}</p>&nbsp;
          </div>
          <div className="row full-stack">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal">
                {textData.layer6.keyFeatures.map((feature, index) => {
                  return (
                    <div className="d-flex w-100 list-item" key={index}>
                      <img src={textData.bulletPoints.img} alt="bullet-point" />
                      <div>
                        <p className="fst-italic text-20">
                          <strong>{feature.title}</strong>
                        </p>
                            <p className="portal-desc text-20">{feature.description}</p>
                      </div>
                    </div>
                  );
                })}
          <div className="pt-4 text-20">
          <p className="mb-0  pb-2 AIuseCase"><strong>{textData.layer6.body.title}</strong></p>
          <ul>
            <li>
          <p className="pb-2 portal-desc text-20">{textData.layer6.body.description.desc1}</p>
            </li>
            <li>
          <p className="pb-2 portal-desc text-20">{textData.layer6.body.description.desc2}</p>
            </li>
          </ul>
          </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12   d-flex justify-content-center align-items-center">
              <img
                src={textData.layer6.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
          <div className="pt-4 text-20">
            <p className="pb-2 text-20">{textData.layer6.body.text2}</p>
          </div>
        </div>
      </div>

	  <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-0"><span>{textData.layer7.heading}</span></h1>&nbsp;
          <div className="p-0 text-20">
            <p>{textData.layer7.body.text1}</p>&nbsp;
          </div>
          <div className="row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.layer7.img}
                className="img-fluid ModernPortals-left-img2"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal">
                {textData.layer7.keyFeatures.map((feature, index) => {
                  return (
                    <div className="d-flex w-100 list-item" key={index}>
                      <img src={textData.bulletPoints.img} alt="bullet-point" />
                      <div>
                        <p className="fst-italic text-20">
                          <strong>{feature.title}</strong>
                        </p>
                        <p className="portal-desc text-20">{feature.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="pt-4 text-20">
            <p>{textData.layer7.body.text2}</p>
          </div>
        </div>
      </div>

	  <div className="container-fluid ModernPortals second">
        <div className="container">
          <h1 className="mb-0"><span>{textData.layer8.heading}</span></h1>&nbsp;
          <div className="p-0 text-20">
            <p>{textData.layer8.body.text1}</p>&nbsp;
          </div>
          <div className="row full-stack">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal">
                {textData.layer8.keyFeatures.map((feature, index) => {
                  return (
                    <div className="d-flex w-100 list-item" key={index}>
                      <img src={textData.bulletPoints.img} alt="bullet-point" />
                      <div>
                        <p className="fst-italic text-20">
                          <strong>{feature.title}</strong>
                        </p>
                        <p className="portal-desc text-20">{feature.description}</p>
                      </div>
                    </div>
                  );
                })}
                <p className="pt-4 portal-desc  text-20">{textData.layer8.body.text2}</p>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 full-stack  d-flex justify-content-center align-items-center">
              <img
                src={textData.layer8.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DigitalTransformation;
